import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
import appPlay from "../assets/images/app-play.svg";
import googlePlay from "../assets/images/google-play.svg";
import mobilApp from "../assets/images/mobil-app.webp";
import aboutsBanner from "../assets/images/abouts-banner.webp";
import happyIcon from "../assets/images/happy-icon.webp";
import whyChooseIcon1 from "../assets/images/whyChoose-icon1.svg";
import whyChooseIcon2 from "../assets/images/whyChoose-icon2.svg";
import whyChooseIcon3 from "../assets/images/whyChoose-icon3.svg";
import whyChooseIcon4 from "../assets/images/whyChoose-icon4.svg";
import { useEffect } from "react";
import { scrollToTop } from "../utils/Helper";
const Aboutus = () => {
  useEffect(() => {
    scrollToTop();
  }, []);
  return (
    <div className="wrapper">
      <Header isBackEnable={true} />
      <main className="main-curve-top">
        <div className="happy-left">&nbsp;</div>
        <div className="happy-right">&nbsp;</div>
        <section className="join-sec text-center aboutsPage-banner">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="bloglist-banner content-block">
                  <h1 className="title h1">
                    Built by HE—Designed for Seamless Collaboration & Success
                  </h1>
                  <div className="blog-banner">
                    <img
                      src={aboutsBanner}
                      alt="aboutsBanner"
                      className="bloglistBanner"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="whoweAre-sec">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-4 col-md-4">
                <div className="whoweAre-left">
                  <img src={happyIcon} alt="happyIcon" className="happyIcon" />
                </div>
              </div>
              <div className="col-lg-8 col-md-8">
                <div className="whoweAre-right">
                  <h2>Who We Are</h2>
                  <p>
                    At Happy Ending (<span>HE</span>), we believe in
                    transforming the way businesses handle projects. Unlike
                    conventional project management tools that focus solely on
                    tasks, we prioritize seamless client collaboration,
                    efficient workflows, and profitability. Our platform ensures
                    that businesses not only meet their goals but also foster
                    long-term client relationships.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="ourVision-sec">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <div className="ourVision-left">
                  <h2>Our Mission</h2>
                  <p>
                    To empower professionals and teams with a simplified,
                    client-focused project management solution that enhances
                    productivity, improves communication, and streamlines
                    operations.
                  </p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="ourVision-right">
                  <h2>Our Vision</h2>
                  <p>
                    We envision a world where project management is not just
                    about deadlines and deliverables but about creating
                    meaningful business relationships that drive success.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="whyChoose-sec">
          <div className="container">
            <div className="head-top-content">
              <h2>Why Choose Us?</h2>
              <p>
                Effortless Project Management, Seamless Client Collaboration
              </p>
            </div>
            <div className="row">
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="whyChoose-content">
                  <img
                    src={whyChooseIcon1}
                    alt="whyChooseIcon1"
                    className="whyChooseIcon"
                  />
                  <h4>Client-Centric Approach</h4>
                  <p>
                    We prioritize transparent communication and strong client
                    relationships to ensure smooth collaboration and lasting
                    trust.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="whyChoose-content">
                  <img
                    src={whyChooseIcon2}
                    alt="whyChooseIcon2"
                    className="whyChooseIcon"
                  />
                  <h4>Efficiency & Automation</h4>
                  <p>
                    Automate processes, reduce manual effort, and keep projects
                    on track with smart, time-saving solutions.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="whyChoose-content">
                  <img
                    src={whyChooseIcon3}
                    alt="whyChooseIcon3"
                    className="whyChooseIcon"
                  />
                  <h4>Data-Driven Insights</h4>
                  <p>
                    Make informed choices with powerful analytics and real-time
                    reporting for improved project performance.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="whyChoose-content">
                  <img
                    src={whyChooseIcon4}
                    alt="whyChooseIcon4"
                    className="whyChooseIcon"
                  />
                  <h4>Flexible & Scalable Solutions</h4>
                  <p>
                    Whether you’re a freelancer, small business, or enterprise,
                    HE adapts to your needs and grows with you.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="business-sec">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <div className="business-content">
                  <h3>Your Business, Your Rules – Access It Anywhere</h3>
                  <p>
                    Take control of your projects with our powerful mobile and
                    web applications. Whether you’re in the office or on the
                    move, stay connected with your clients, streamline
                    workflows, and maximize profits—all from one intuitive
                    platform.
                  </p>
                  <div className="play-btn-group">
                    <a href="#">
                      {" "}
                      <img src={appPlay} alt="appPlay" />
                    </a>
                    <a href="#">
                      {" "}
                      <img src={googlePlay} alt="googlePlay" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <img src={mobilApp} alt="mobilApp" className="mobilApp" />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Aboutus;
